import { Box, CircularProgress, Stack, Typography } from '@rossum/ui/material';
import type { TaskItem } from '../types';

type TaskListProps = {
  tasks: TaskItem[];
};

export const TaskList = ({ tasks }: TaskListProps) => {
  if (tasks.length === 0) return null;

  return (
    <Stack
      sx={{
        px: 2,
        py: 1,
        gap: 0.5,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      {tasks.map(t => {
        const done = t.status === 'completed';
        const color = done ? 'success.main' : 'text.secondary';
        return (
          <Stack key={t.id} direction="row" alignItems="center" gap={0.75}>
            <Box
              sx={{
                width: 16,
                height: 16,
                display: 'grid',
                placeItems: 'center',
                flexShrink: 0,
              }}
            >
              {t.status === 'in_progress' ? (
                <CircularProgress size={14} />
              ) : (
                <Typography variant="caption" sx={{ lineHeight: 1, color }}>
                  {done ? '✓' : '○'}
                </Typography>
              )}
            </Box>
            <Typography variant="caption" sx={{ color, lineHeight: 1.4 }}>
              {t.subject}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};
